// extracted by mini-css-extract-plugin
module.exports = {"section_aboutus_hero":"hero_section_aboutus_hero__n4H3a","wrapper":"hero_wrapper__iWm4x"};